
import axiosInstance from '../../utils/axiosInstance';
import { loadingEndedAction, loadingStartedAction } from '../isLoading/actions';
import { loadCashRequestApprovalsAction } from './actions';

export const loadCashRequestApprovals =
  (page = 0) =>
  (dispatch) => {
    dispatch(loadingStartedAction());
    const uri = "/api/cash_request_approvals";
    const endpoint = page ? `${uri}?page=${page + 1}` : uri;

    axiosInstance
      .get(endpoint)
      .then((res) => {
        if (res.status === 200)
          dispatch(loadCashRequestApprovalsAction(res.data));
        dispatch(loadingEndedAction());
      })
      .catch((err) => {
        console.log("Request Denied");
        dispatch(loadingEndedAction());
      });
  };